import ITextProps from '../ITextProps';

import { FontWeight } from 'shared/enums';

import c from './textButton.module.scss';

const TextButton = ({ children, className, color, text, textAlign, fontWeight, noWrap }: ITextProps) => {
  return (
    <div
      className={`${className || ''} ${c.textButton}`}
      style={{
        textAlign: textAlign || 'initial',
        fontWeight: fontWeight || FontWeight.Light,
        color: `var(${color})`,
        whiteSpace: noWrap ? 'nowrap' : undefined,
      }}>
      {text || children}
    </div>
  );
};

export default TextButton;
